<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-radio-group v-model="automationType" size="small">
        <el-radio-button label="0">For Offer</el-radio-button>
        <el-radio-button label="1">For Require</el-radio-button>
        <el-radio-button label="2">Automation Record</el-radio-button>
      </el-radio-group>
    </div>

    <template v-if="automationType !== '2'">
      <div class="automation-title">Groups</div>
      <div v-if="customerGroupListFilter.length > 0">
        <table>
          <tr>
            <th>Group Name</th>
            <th>Send to</th>
            <th>Sales</th>
            <th>&nbsp;</th>
          </tr>
          <tr v-for="item in customerGroupListFilter" :key="item.group_id">
            <td>{{ item.group_name }}&nbsp;&lt;{{ item.group_id }}&gt;&nbsp;(<span style="color:blue;font-weight:bold;">{{ item.is_enable === '1' ? '启用' : '未启用' }}</span>)</td>
            <td>{{ !item.contact_name ? 'All key contacts' : item.contact_name }}</td>
            <td>{{ item.create_oper_name }}</td>
            <td><el-button type="danger" size="mini" @click="removeGroup(item.group_id)">Remove</el-button></td>
          </tr>
        </table>
      </div>
      <div v-else style="text-align:center;height:50px;line-height:50px;">
        Not in any group
      </div>
      <div style="border-top:1px solid #999;padding:6px 0;">
        <el-select v-model="groupForm.contact_id">
          <el-option label="All key contacts" :value="0"></el-option>
          <el-option v-for="item in contactKeyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        &nbsp;
        <el-select v-model="groupForm.group_id" style="width:300px">
          <el-option label="select group ..." :value="null"></el-option>
          <el-option v-for="item in groupListFilter" v-if="customerGroupListFilter.filter(r => r.group_id === item.id).length === 0" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        &nbsp;
        <el-button type="primary" :disabled="!groupForm.group_id" @click="addToGroup">Add to group</el-button>
      </div>

      <div class="automation-title">Items</div>
      <div v-if="customerGroupListFilter.length > 0">
        <div v-for="group in customerGroupListFilter" :key="group.group_id">
          <div style="padding:4px 0;font-weight:bold;">{{ group.group_name }}&nbsp;&lt;{{ group.group_id }}&gt;</div>
          <el-tag
            v-for="(item, index) in groupsClassList.filter(r => r.group_id === group.group_id)"
            :key="item.id">
            {{ item.name }}
          </el-tag>
        </div>
      </div>
      <div v-else style="text-align:center;height:50px;line-height:50px;">
        Not in any group
      </div>

      <div class="automation-title">Schedules</div>
      <div v-if="customerGroupListFilter.length > 0">
        <div v-for="group in customerGroupListFilter" :key="group.group_id">
          <div style="padding:4px 0;font-weight:bold;">{{ group.group_name }}&nbsp;&lt;{{ group.group_id }}&gt;</div>
          <el-tag
            v-for="(item, index) in groupsScheduleList.filter(r => r.group_id === group.group_id)"
            :key="item.id"
            type="success">
            {{ getDayName(item.weekday) }}&nbsp;{{ item.time }}
          </el-tag>
        </div>
      </div>
      <div v-else style="text-align:center;height:50px;line-height:50px;">
        Not in any group
      </div>
    </template>
    <div v-else style="text-align:center;padding-top:50px;">
      No record.
    </div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      company: {
        id: this.$route.params.id,
        name: ''
      },
      automationType: '0',
      groupForm: {
        contact_id: 0,
        group_id: null
      },
      contactList: [],
      groupList: [],
      customerGroupList: [],
      groupsClassList: [],
      groupsScheduleList: [],
      weekdayList: [
        { id: 0, name: 'Sunday' },
        { id: 1, name: 'Monday' },
        { id: 2, name: 'Tuesday' },
        { id: 3, name: 'Wednesday' },
        { id: 4, name: 'Thursday' },
        { id: 5, name: 'Friday' },
        { id: 6, name: 'Saturday' }
      ],

      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    contactKeyList () {
      return this.contactList.filter(c => c.is_key === '1')
    },
    groupListFilter () {
      return this.groupList.filter(r => r.type === this.automationType)
    },
    customerGroupListFilter () {
      return this.customerGroupList.filter(r => r.group_type === this.automationType)
    },
    customerGroupListOffer () {
      return this.customerGroupList.filter(r => r.group_type === '0')
    },
    customerGroupListRequire () {
      return this.customerGroupList.filter(r => r.group_type === '1')
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchContactList()
    this.fetchGroupList()
    this.fetchCustomerGroupList()
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
        }
      })
    },
    fetchContactList () {
      this.$http.get('/dbapi/company_contact_list', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.contactList = data.list
      })
    },
    fetchGroupList () {
      this.$http.get('/dbapi/group_list').then(data => {
        this.groupList = data.list
      })
    },
    fetchCustomerGroupList () {
      this.$http.get('/dbapi/group_company_list', {
        params: {
          // type: this.automationType,
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.customerGroupList = data.list
        if (this.customerGroupList.length > 0) {
          this.fetchGroupsClassList()
          this.fetchGroupsScheduleList()
        }
      })
    },
    fetchGroupsClassList () {
      this.$http.get('/dbapi/group_class_list', {
        params: {
          group_ids: this.customerGroupList.map(r => r.group_id)
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.groupsClassList = data.list
      })
    },
    fetchGroupsScheduleList () {
      this.$http.get('/dbapi/group_schedule_list', {
        params: {
          group_ids: this.customerGroupList.map(r => r.group_id)
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.groupsScheduleList = data.list
      })
    },
    getDayName (id) {
      let arr = this.weekdayList.filter(r => r.id === id)
      if (arr.length > 0) {
        return arr[0].name
      }
      return ''
    },
    addToGroup () {
      this.$http.post('/dbapi/group_company_insert_1', {
        company_id: this.$route.params.id,
        ...this.groupForm
      }).then(data => {
        this.fetchCustomerGroupList()
        this.groupForm.group_id = null
      })
    },
    removeGroup (id) {
      this.$confirm('确定要退出这个Group吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/group_company_del', {
          group_id: id,
          company_id: this.$route.params.id
        }).then(data => {
          this.fetchCustomerGroupList()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.automation-title {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 2px solid #118333;
  color: #118333;
  padding: 6px 0;
  margin-top: 30px;
  margin-bottom: 10px;
}
</style>